import { SINGER_RANK } from 'appConstants';
import Select from 'components/Select';
import React from 'react';

const SingerRankSelect = props => {
  return <Select options={SINGER_RANK} {...props} />;
};

export default SingerRankSelect;
